import * as React from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

/**
 * Ô tìm kiếm. Kính lúp là affordance bắt buộc — không có nó thì ô input trông
 * như mọi ô input khác. Giữ icon ở ĐÚNG MỘT chỗ này thay vì để ba trang danh
 * sách đơn mỗi trang tự import `Search` rồi tự căn vị trí một kiểu.
 */
export const SearchInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <div className="relative" data-slot="search">
    <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted" />
    <Input ref={ref} type="search" className={cn('pl-9', className)} {...props} />
  </div>
))
SearchInput.displayName = 'SearchInput'
